import { Component } from '@angular/core';

@Component({
  selector: 'app-blog-190625',
  templateUrl: './blog-190625.component.html'
})
export class Blog190625Component { }
